import type { DragPreviewState } from './types';
import { isFiniteNumber } from './untils';

/**
 * Creates initial drag preview state from pointer and item rectangle.
 */
export function createDragPreviewState({
  pointerX,
  pointerY,
  itemLeft,
  itemTop,
}: {
  pointerX: number;
  pointerY: number;
  itemLeft: number;
  itemTop: number;
}): DragPreviewState {
  if (
    !isFiniteNumber(pointerX) ||
    !isFiniteNumber(pointerY) ||
    !isFiniteNumber(itemLeft) ||
    !isFiniteNumber(itemTop)
  ) {
    return {
      x: 0,
      y: 0,
      offsetX: 0,
      offsetY: 0,
    };
  }

  return {
    x: pointerX,
    y: pointerY,
    offsetX: pointerX - itemLeft,
    offsetY: pointerY - itemTop,
  };
}

/**
 * Updates drag preview position while preserving initial offset.
 */
export function updateDragPreviewState({
  previous,
  pointerX,
  pointerY,
}: {
  previous: DragPreviewState;
  pointerX: number;
  pointerY: number;
}): DragPreviewState {
  if (!isFiniteNumber(pointerX) || !isFiniteNumber(pointerY)) {
    return previous;
  }

  return {
    ...previous,
    x: pointerX,
    y: pointerY,
  };
}
